import React from 'react';
import { Helmet } from 'react-helmet';

function resetJsMenu(props) {
    const { sectionId, pageId } = props;

    if (window.jsMenu === undefined) {
        window.jsMenu = {
            header: 'header'        
            ,sidebar: 'siderbar'
            ,content: 'content'
            ,footer: 'footer'
            ,sectionId: sectionId
            ,pageId: pageId
            ,autoLangUrl: true
            //,lang: lang
            ,useCSS: true
            ,breadcrumbs: true
        };
    }
}

function WebLayout (props) {

    const { component: Component, path, ...rest } = props;

    const SFC_DOMAIN = `${process.env['REACT_APP_SFC_DOMAIN']}`;
    const SFCSC_DOMAIN = `${process.env['REACT_APP_SFCSC_DOMAIN']}`;

    resetJsMenu(props); 


    let menujs;
    if (window.location.hostname === SFCSC_DOMAIN) {
        menujs = `//${SFCSC_DOMAIN}/TuniS/${SFC_DOMAIN}/web/js-menu/menu.js`;
    } else {
        menujs = `//${SFC_DOMAIN}/web/js-menu/menu.js`;
    }


    return (
        <div>
            <Helmet>
                <link rel='stylesheet' type='text/css' href={`//${process.env['REACT_APP_SFC_DOMAIN']}/js/plugins/bootstrap/css/bootstrap.min.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/normalize.css/normalize.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/select2/css/select2.min.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/daterangepicker/daterangepicker.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/paginationjs/pagination.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/slick-carousel/slick/slick.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/plyr/plyr.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/jquery/jquery-ui.datepicker.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/js/plugins/swiper/swiper.min.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/assets/plugins/@fortawesome/fontawesome-free/css/all.min.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/css/common.css`} />
                <link rel='stylesheet' type='text/css' href={`//${SFC_DOMAIN}/css/inner.css`} />

                <script type="text/javascript" src={menujs}></script>
                
            </Helmet>
            <div id="header"></div>
            <div id="siderbar"></div>
            <div id="content">
                <div className="breadcrumbs"></div>
                <Component {...rest}/>
            </div>
            <div id="footer"></div>
        </div>
    );
}

export default WebLayout;